'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const MICROKNOWLEDGE_MAX_LENGTHS = {
    IMAGE: {
        MAX_TITLE_LENGTH: 40,
        MAX_CONTENT_LENGTH: 500,
    },
    VIDEO: {
        MAX_TITLE_LENGTH: 40,
    },
    CHAPTER: {
        MAX_TITLE_LENGTH: 40,
    },
};

exports.MICROKNOWLEDGE_MAX_LENGTHS = MICROKNOWLEDGE_MAX_LENGTHS;
//# sourceMappingURL=microknowledge-max-lengths.js.map
